<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <img :src="Images.LOGO" alt="Logo">
          <p class="footer-logo-text">科技新时代，电子新世纪</p>
        </div>
        <div class="footer-links">
          <h4 class="footer-links-title">快速链接</h4>
          <ul class="footer-links-list">
            <li><router-link to="/home" class="footer-link">首页</router-link></li>
            <li><router-link to="/products" class="footer-link">产品与服务</router-link></li>
            <li><router-link to="/news" class="footer-link">新闻中心</router-link></li>
            <li><router-link to="/about" class="footer-link">关于我们</router-link></li>
            <li><router-link to="/contact" class="footer-link">联系我们</router-link></li>
          </ul>
        </div>
        <div class="footer-contact">
          <h4 class="footer-contact-title">联系我们</h4>
          <div class="footer-contact-item">
            <img :src="Images.address" alt="地址" class="footer-contact-icon">
            <span class="footer-contact-text">深圳市龙华区大浪街道浪口社区华霆路387号5栋2层</span>
          </div>
          <div class="footer-contact-item">
            <img :src="Images.phone" alt="电话" class="footer-contact-icon">
            <span class="footer-contact-text">0755-21004378</span>
          </div>
          <div class="footer-contact-item">
            <img :src="Images.email" alt="邮箱" class="footer-contact-icon">
            <span class="footer-contact-text">1607845075@qq.com</span>
          </div>
        </div>
        <div class="footer-newsletter">
          <h4 class="footer-newsletter-title">订阅我们</h4>

          <span class="footer-contact-text">订阅我们的邮箱获取最新资讯</span>
          
          <div class="footer-newsletter-form">
            <input type="email" placeholder="您的邮箱地址" class="footer-newsletter-input">
            <button class="footer-newsletter-button"><img :src="Images.send" alt="发送"></button>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-bottom-left">
          <div class="footer-info-row">
            <p class="footer-copyright">©2023-2026 深圳市竟加技术有限公司</p>
            <div class="footer-icp-container">
              <p class="footer-icp small">
                <a href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">粤ICP备2023104005号</a>
              </p>
              <p class="footer-icp small">
                <img :src="Images.emblem" alt="国徽" class="emblem-icon">
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002002853" rel="noreferrer" target="_blank">粤公网安备44030002002853号</a>
              </p>
            </div>
          </div>
        </div>
        <div class="footer-social">
          <a href="#" class="footer-social-link">隐私政策</a>
          <a href="#" class="footer-social-link">服务条款</a>
          <a href="#" class="footer-social-link">网站地址</a>
        </div>
      </div>
      <div class="footer-to-top" @click="scrollToTop" tabindex="-1">
        <img :src="Images.to_top" alt="回到顶部">
      </div>
    </div>
  </footer>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'FooterComponent',
  data() {
    return {
      Images
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  padding: 50px 0 20px;
}

.container {
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo img {
  width: 201px;
  height: 28px;
  margin-bottom: 15px;
}
.footer-logo p {
  font-size: 18.5px;
  color: #FFFFFF;
}

.footer-icp {
  margin-top: 15px;
  font-size: 12px;
}

.footer-icp a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-icp a:hover {
  color: #ff6b00;
}

.emblem-icon {
  width: 12px;
  height: 12px;
  margin-right: 6px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -2px;
}

.footer-company {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.footer-links-title,
.footer-contact-title,
.footer-newsletter-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-link {
  color: #ccc;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #ff6b00;
}

.footer-contact-item {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 15px;
}

.footer-contact-icon {
  width: 16px;
  height: 16px;
}

.footer-contact-text {
  color: #ccc;
  font-size: 14px;
}

.footer-newsletter-form {
  display: flex;
  gap: 0;
}

.footer-newsletter-input {
  padding: 10px;
  border: none;
  border-radius: 4px 0 0 4px;
  width: 200px;
  font-size: 14px;
}

.footer-newsletter-button {
  background-color: #ff6b00;
  border: none;
  padding: 10px 15px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

.footer-newsletter-button img {
  width: 16px;
  height: 16px;
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-bottom-left {
  display: flex;
  align-items: center;
}

.footer-info-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-icp-container {
  display: flex;
  gap: 15px;
  align-items: center;
}

.footer-copyright {
  color: #999;
  font-size: 14px;
  margin: 0;
}

.footer-icp.small {
  margin: 0;
  font-size: 14px;
}

.footer-icp.small a {
  color: #666;
}

.footer-social {
  display: flex;
  gap: 20px;
}

.footer-social-link {
  color: #999;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-social-link:hover {
  color: #ff6b00;
}

.footer-to-top {
  position: fixed;
  bottom: 35px;
  right: 35px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
  outline: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
}

.footer-to-top:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.footer-to-top img {
  width: 70px;
  height: 70px;
}
</style>